import { render, staticRenderFns } from "./ReferralsView.vue?vue&type=template&id=6693406f&"
import script from "./ReferralsView.vue?vue&type=script&lang=js&"
export * from "./ReferralsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports